import { render, staticRenderFns } from "./ClientesReferenciasPedimentos.vue?vue&type=template&id=fc3f36c4&scoped=true&"
import script from "./ClientesReferenciasPedimentos.vue?vue&type=script&lang=js&"
export * from "./ClientesReferenciasPedimentos.vue?vue&type=script&lang=js&"
import style0 from "./ClientesReferenciasPedimentos.vue?vue&type=style&index=0&id=fc3f36c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3f36c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VBreadcrumbs,VBtn,VCardText,VCardTitle,VCol,VContainer,VFlex,VIcon,VLayout,VRow,VTab,VTabItem,VTabs,VTabsSlider})
